<template>
    <div
        class="banner-video"
        :class="{
            autoplay: isAutoPlay,
            'play-inline': !playOnPop,
            mobile: isMobile,
            loading: isLoading,
            'is-play': isPlay,
            'is-pause': isPause && !isStop,
            'bottom-align': !playOnPop && controls && !option.autoHeight,
            'auto-height': option.autoHeight
        }"
    >
        <site-img
            class="preview"
            v-show="playOnPop || isStop"
            :src="preview"
            type="bgImg"
        />
        <div
            v-show="src && !option.hidePlayButton && playVideoShow"
            :class="isLoading ? 'video-loading' : 'play-video'"
            @click.stop="doPlay"
        ></div>
      
        <site-video
            v-if="!isSSRServer && !playOnPop"
            v-show="isShow || isAutoPlay"
            ref="siteVideo"
            :src="src || ''"
            :preview="preview"
            :autoplay="isAutoPlay"
            :loop="isAutoPlay"
            :muted="isAutoPlay || option.videoMuted"
            :controls="controls"
            :playsinline="playInline"
            :canplay="readyPlay"
            :pause="videoPause"
            :play="videoPlay"
            :ended="doStop"
            :seeked="doSeeked"
            :error="videoError"
            :volume="volume"
            @loadedmetadata="loadedmetadata"
            @loadPreview="loadPreview"
            @setFacebook="setFacebook"
        />
        <i
            v-if="!playOnPop && showMuted && !controls"
            v-show="isPlay && !curFacebook"
            class="iconfont"
            :class="muted ? 'icon-video-muted' : 'icon-video-sound'"
            @click.stop="toggleMuted"
        ></i>
        
        <teleport to="#teleported" v-if="playOnPop && isMounted">
            <div class="banner-video-teleport" :class="popClass">
                <div
                    class="pop-video"
                    :class="{ 'pop-hide': !isShow, mobile: isMobile }"
                >
                    <div class="pop-contain">
                        <!-- playsinline required for true， prevent ios，safari Pop up again 。 The logic of the pop-up window is banner-video self-controlled  -->
                        <site-video 
                            v-if="!isSSRServer"
                            ref="siteVideo"
                            :src="src || ''"
                            :preview="preview"
                            :autoplay="isAutoPlay"
                            :loop="isAutoPlay"
                            :muted="isAutoPlay || option.videoMuted"
                            :controls="controls"
                            :playsinline="playInline"
                            :canplay="readyPlay"
                            :pause="videoPause"
                            :play="videoPlay"
                            :ended="doStop"
                            :seeked="doSeeked"
                            :error="videoError"
                            :volume="volume"
                            @loadedmetadata="loadedmetadata"
                            @loadPreview="loadPreview"
                            @setFacebook="setFacebook"
                        />
                        <span
                            v-if="!isMobile"
                            class="iconfont icon-close"
                            @click.stop="doStop(true)"
                        ></span>
                        <i
                            v-if="showMuted && !controls"
                            v-show="isPlay && !curFacebook"
                            class="iconfont"
                            :class="muted ? 'icon-video-muted' : 'icon-video-sound'"
                            @click.stop="toggleMuted"
                        ></i>
                    </div>
                </div>
                <div
                    v-if="playOnPop && isMobile && isShow"
                    class="video-mask"
                    @click.stop="doStop(true)"
                ></div>
                <span
                    v-if="playOnPop && isMobile && isShow"
                    class="pop-video-close iconfont icon-clear_circle_outlined"
                    @click.stop="doStop(true)"
                ></span>
            </div>
        </teleport>
    </div>
</template>

<script>
import util from '../common/util.js';
import global from '../common/global.js';

export default {
    emits: ['updateRatio', 'updatePlay'],
    name: 'BannerVideo',
    props: {
        src: {
            type: String,
            default: ''
        },
        previewSrc: {
            type: String,
            default: ''
        },
        isContain: {
            type: Boolean,
            default: false
        },
        popClass: {
            type: String,
            default: ''
        },
        option: {
            type: Object,
            default: () => ({
                autoplay: false,
                playInline: true,
                showProgress: true,
                videoMuted: false,
                showMuteButton: true,
                autoHeight: false,
                hidePlayButton: false,
                volume: null, // volume configuration item
                videoLoop: false //  for true time video loop ， ignoring the three limit
            })
        }
    },
    data: function() {
        return {
            isSSRServer: util.isSSRServer,
            canLoop: true,
            playVideoShow: !this.option.autoplay,
            preview: this.previewSrc,
            isPlay: false,
            isPause: false,
            isStop: true,
            isShow: false,
            ready: false,
            videoLoad: false,
            isLoading: false,
            videoRatio: 0,
            muted: this.option.videoMuted || this.option.autoplay,
            curFacebook: false,
            isMounted: false,
        };
    },
    computed: {
        playInline() {
            if (this.option.autoplay) {
                return true;
            } else {
                return this.option.playInline === undefined
                    ? true
                    : this.option.playInline;
            }
        },
        isMobile() {
            return this.platform.isMobile;
        },
        isAutoPlay() {
            return this.option.autoplay;
        },
        playOnPop() {
            //fix bug CHIME-18744
            return !this.playInline && !util.inCmsPageEditor;
        },
        controls() {
            return (
                this.option.showProgress || (this.isMobile && this.isAutoPlay)
            );
        },
        showMuted() {
            return !this.controls && this.option.showMuteButton;
        },
        volume() {
            return this.option.volume;
        }
    },
    watch: {
        isLoading(value) {
            this.ready && !value && this.doPlay();
        },
        videoRatio(value) {
            this.$emit('updateRatio', value);
        },
        isPlay(value) {
            this.$emit('updatePlay', value);
        },
        src() {
            this.doStop(true);
        },
        isAutoPlay(a) {
            if (a) {
                this.doPlay();
            } else {
                this.doStop(true);
            }
        },
        previewSrc(val) {
            this.preview = val || ''
            this.playVideoShow = true;
        },
        isShow(v) {
            if (this.playOnPop) {
                if (v) {
                    util.enableScroll(false);
                } else {
                    util.enableScroll(true);
                }
            }
        }
    },
    created() {
        this.count = 0;
    },
    mounted() {
        this.isMounted = true;
        global.resize(this.calcVideoStyle);
    },
    methods: {
        setFacebook() {
            //facebook (The video of the platform needs to hide the mute button
            this.curFacebook = true;
            this.isLoading = false;
        },
        loadedmetadata(videoIns) {
            this.$video = videoIns;
            this.videoLoad = true;
            this.calcVideoStyle();
        },
        readyPlay() {
            this.ready = true;
            this.isLoading = false;
            if (this.isAutoPlay) {
                this.isPlay = true;
                this.isStop = false;
            }
        },
        videoPause() {
            this.isPause = true;
            this.isPlay = false;
            this.doPause();
            if (
                (!this.controls || !this.option.autoHeight) &&
                !this.isAutoPlay &&
                this.playInline
            ) {
                this.playVideoShow = true;
            }
        },
        videoPlay() {
            console.log('------videoPlay------');
            this.isPlay = true;
            this.isShow = true;
            this.isStop = false;
            this.isPause = false;
            this.playVideoShow = false;
            this.doPlay();
        },
        videoError() {
            this.isLoading = false;
        },
        toggleMuted() {
            let muted = !this.muted;
            this.controlMuted(muted);
            this.muted = muted;
        },
        doPlay() {
            if (this.ready) {
                this.isPause = false;
                this.isPlay = true;
                this.isShow = true;
                this.isStop = false;
                this.playVideoShow = false;
                this.controlPlay();
            } else {
                this.isLoading = true;
                if (this.platform.isIos) {
                    this.controlPlay();
                }
            }
            this.setScrollState();
        },
        doSeeked() {
            if (this.isAutoPlay) {
                this.count++;
                if (this.count >= 3 && !this.option.videoLoop) {
                    this.controlPause();
                    this.canLoop = false;
                }
            }
        },
        doStop(doClose) {
            this.isPlay = false;
            this.isStop = true;
            this.playVideoShow = false;
            this.doPause();
            if (doClose === true) {
                this.isShow = false;
                if (!this.playInline) {
                    this.playVideoShow = true;
                }
            }
            if (!this.isAutoPlay && this.playInline) {
                this.playVideoShow = true;
            }
          
        },
        doPause() {
            console.log('doPause ===')
            this.isPause = true;
            this.isPlay = false;
            if (!this.ready) {
                return; 
            }
            this.controlPause();
        },
        calcVideoStyle() {
            if (!this.videoLoad || (!this.playOnPop && this.isContain)) {
                return; 
            }
            let ratio = 0;
            let height = window.innerHeight;
            
            if (this.playOnPop) {
                ratio = height / window.innerWidth;
            } else {
                ratio = this.$el.offsetHeight / this.$el.offsetWidth;
            }

            if (this.$video && this.$video.calcVideoStyle) {
                this.videoRatio = this.$video.calcVideoStyle({
                    el: this.$el,
                    playOnPop: this.playOnPop,
                    autoHeight: this.option.autoHeight,
                    height,
                    ratio
                });
            }
        },
        setScrollState() {
            if (this.playOnPop) {
                // util.scrollIntoView(this.$el);
            
            }
        },
        loadPreview(src) {
            console.log('loadPreview ==>>>', src)
            this.preview = this.previewSrc || src;
        },
        async controlPlay() {
            await this.$nextTick();
            if (this.$video?.playVideo) {
                this.$video.playVideo();
            }
        },
        controlPause() {
            if (this.$video?.pauseVideo) {
                this.$video.pauseVideo();
            }
        },
        controlMuted(muted) {
            if (this.$video?.toggleMuted) {
                this.$video.toggleMuted(muted);
            }
        }
    },
    unmounted() {
        !(!this.playOnPop && this.isContain) &&
            global.resize(this.calcVideoStyle, true);
    }
};
</script>

<style lang="scss">
@import '../theme/media.scss';
.banner-video {
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #000;
    &.bottom-align {
        align-items: flex-end;
    }
    .preview {
        background-color: #efefef;
        overflow: hidden;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-size: cover;
        background-position: center;
        z-index: 1;
    }
    .play-video {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 80px;
        height: 80px;
        border: 4px solid white;
        border-radius: 50%;
        cursor: pointer;
        z-index: 2;
        &:after {
            content: '';
            position: absolute;
            top: 50%;
            left: 24px;
            transform: translateY(-50%);
            border-top: 20px solid transparent;
            border-bottom: 20px solid transparent;
            border-left: 30px solid white;
        }
        @include media-1080 {
            width: 60px;
            height: 60px;
            &:after {
                left: 17px;
                border-top: 15px solid transparent;
                border-bottom: 15px solid transparent;
                border-left: 22px solid white;
            }
        }
        @include media-600 {
            border: 2px solid white;
            width: 40px;
            height: 40px;
            &:after {
                left: 12px;
                border-top: 10px solid transparent;
                border-bottom: 10px solid transparent;
                border-left: 15px solid white;
            }
        }
    }
    .video-loading {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 80px;
        height: 80px;
        background: url(//static.chimeroi.com/site/images/home/loading.gif)
            no-repeat;
        background-size: cover;
        z-index: 2;
        @include media-1080 {
            width: 60px;
            height: 60px;
        }
        @include media-600 {
            width: 40px;
            height: 40px;
        }
    }
   
    .icon-video-muted,
    .icon-video-sound {
        position: absolute;
        width: 36px;
        height: 36px;
        right: 20px;
        bottom: 20px;
        font-size: 16px;
        color: #fff;
        border-radius: 4px;
        z-index: 9;
        cursor: pointer;
        text-align: center;
        vertical-align: middle;
        line-height: 36px;
        &::after {
            background: #282828;
            opacity: 0.3;
            border-radius: 4px;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            content: '';
            z-index: -1;
        }
    }
   
}

.banner-video-teleport{
    .pop-video {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 9999;
        background: rgba(0, 0, 0, 0.15);
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        width:100vw;
        .pop-contain {
            position: relative;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            @include media-600 {
                width: 100%;
                height: 100%;
            }
        }
        &.mobile {
            top: 50%;
            transform: translate(0, -50%);
        }
        &.pop-hide {
            display:none;
        }
        // pc close
        .icon-close {
            position: absolute;
            z-index: 1;
            right: 40px;
            top: 10px;
            width: 24px;
            height: 24px;
            cursor: pointer;
            font-size: 17px;
            color: #ffffff;
            text-shadow: 0 1px 1px rgba(8, 17, 38, 0.5);
            &::before {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
    }

    // mobile close
    .pop-video-close {
        display: block;
        position: fixed;
        top: 15px;
        right: 15px;
        color: #fff;
        border-radius: 50%;
        font-size: 20px;
        width: 22px;
        height: 22px;
        z-index: 9999;
    }

    .video-mask {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
        z-index: 999;
    }
}
</style>
